import type { FC } from 'react';
import type { FragmentType } from '@packages/gql/generated/shopping';
import { unmask } from '@packages/gql/src/betterMasking';
import type { ProductCategoryNavigationMobileWorkaroundFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductCategoryNavigationMobileWorkaroundFragmentFragmentDoc';
import type { ProductCategoryNavigationMobileFragmentFragmentDoc } from '@packages/gql/generated/shopping/ProductCategoryNavigationMobileFragmentFragmentDoc';

import { CategoryTreeMobileFirst } from '../CategoryTreeMobileFirst/CategoryTreeMobileFirst';
import { useCategoryDataForProductCategoryNavigationMobile } from './useCategoryDataForProductCategoryNavigationMobile';

/* GraphQL */ `
  fragment ProductCategoryNavigationMobileFragment on FlatCategoryItem {
    ...UseCategoryDataForProductCategoryNavigationMobileFragment
  }
`;

/* GraphQL */ `
  fragment ProductCategoryNavigationMobileWorkaroundFragment on CategoryResult {
    ...UseCategoryDataForProductCategoryNavigationMobileWorkaroundFragment
  }
`;

export type ProductCategoryNavigationMobileProps = {
  /** Category items for list navigation */
  maskedItems: Array<FragmentType<typeof ProductCategoryNavigationMobileFragmentFragmentDoc>>;
  /** Root category for upwards navigation */
  maskedResult: FragmentType<typeof ProductCategoryNavigationMobileWorkaroundFragmentFragmentDoc>;
  /** Callback invoked when a category is selected */
  onNavigate?: () => void;
};

/**
 * Displays a single level of categories as navigation items, including upwards if possible.
 * */
export const ProductCategoryNavigationMobile: FC<ProductCategoryNavigationMobileProps> = ({
  maskedItems,
  maskedResult,
  onNavigate,
}) => {
  const items = maskedItems.map((item) =>
    unmask<typeof ProductCategoryNavigationMobileFragmentFragmentDoc>(item),
  );
  const result =
    unmask<typeof ProductCategoryNavigationMobileWorkaroundFragmentFragmentDoc>(maskedResult);

  const categories = useCategoryDataForProductCategoryNavigationMobile(items, result);
  const onNavigateHandler = () => {
    if (onNavigate) {
      onNavigate();
    }
  };

  return <CategoryTreeMobileFirst categories={categories} onNavigate={onNavigateHandler} />;
};
